import { render, staticRenderFns } from "./OFlatpickrWrapper.vue?vue&type=template&id=44fc4713&scoped=true&"
import script from "./OFlatpickrWrapper.vue?vue&type=script&lang=js&"
export * from "./OFlatpickrWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fc4713",
  null
  
)

export default component.exports